import React from 'react';
const ProgramsSection = () => {
  const corePrograms = [{
    emoji: '✨',
    title: 'The 4-Week Neurotoned Reset',
    description: 'A comprehensive introduction to nervous system regulation with daily practices for sustainable healing.'
  }, {
    emoji: '💔',
    title: 'Grief & Loss Healing',
    description: 'Gentle somatic practices to process grief in the body and find resources for moving forward.'
  }, {
    emoji: '⚡️',
    title: 'Conquer Chronic Fear',
    description: 'Tools to identify and transform fear patterns held in the nervous system.'
  }, {
    emoji: '🪖',
    title: 'Overcome Trauma Reactions',
    description: 'Evidence-based approaches to interrupt trauma responses and build new neural pathways.'
  }, {
    emoji: '🌚',
    title: 'Ease Anxiety & Improve Sleep',
    description: 'Calming practices to downregulate the nervous system and prepare for restorative sleep.'
  }, {
    emoji: '🛌',
    title: 'Reset from Chronic Fatigue',
    description: 'Gentle energy restoration practices that honor the body, s, current, capacity, : .'
  }, {
    emoji: '🫥',
    title: 'Reclaim from Dissociation',
    description: 'Grounding techniques to gently bring awareness back to the body when feeling disconnected.'
  }];
  const microPrograms = [{
    title: 'Acupressure for Stress & Trauma',
    description: 'Quick pressure point techniques to release tension and activate the parasympathetic system.'
  }, {
    title: 'Breath Maps for Survival States',
    description: 'Specific breathing patterns designed for different nervous system states.'
  }, {
    title: 'Expressive Arts for Freezing & Shutdown',
    description: 'Creative approaches to gently move through immobilization states.'
  }, {
    title: 'Guided Doodle Flow',
    description: 'Combining mindful movement with creative expression for nervous system regulation.'
  }, {
    title: 'Self-Holding & Tapping Practices',
    description: 'Simple self-touch techniques that signal safety to the nervous system.'
  }, {
    title: 'Body & Boundaries Tools',
    description: 'Practices to strengthen embodied boundary awareness and communication.'
  }];
  return <section id="programs" className="py-20 px-6 md:px-12 bg-white" data-id="element-233">
      <div className="max-w-6xl mx-auto" data-id="element-234">
        <div className="text-center mb-16" data-id="element-235">
          <span className="bg-teal-100 text-teal-800 px-4 py-1 rounded-full text-sm font-semibold inline-block mb-4" data-id="element-236">
            COMPREHENSIVE LIBRARY
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-teal-900 mb-6" data-id="element-237">
            Full Access to Every Neurotoned Program
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-238">
            Each program is designed to be trauma-informed, therapist-created,
            and under 15 minutes/day.
          </p>
        </div>
        <div className="mb-16" data-id="element-239">
          <h3 className="text-2xl font-bold text-teal-800 mb-8 text-center" data-id="element-240">
            Core Programs:
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-241">
            {corePrograms.map((program, index) => <div key={index} className="bg-white border border-teal-100 p-6 rounded-xl shadow-md hover:shadow-lg transition duration-300 transform hover:-translate-y-1" data-id="element-242">
                <div className="bg-teal-50 w-12 h-12 flex items-center justify-center rounded-full mb-4" data-id="element-243">
                  <div className="text-3xl" data-id="element-244">{program.emoji}</div>
                </div>
                <h4 className="text-xl font-semibold text-teal-900 mb-3" data-id="element-245">
                  {program.title}
                </h4>
                <p className="text-gray-700" data-id="element-246">{program.description}</p>
              </div>)}
          </div>
        </div>
        <div data-id="element-247">
          <h3 className="text-2xl font-bold text-teal-800 mb-8 text-center" data-id="element-248">
            Micro Programs:
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-249">
            {microPrograms.map((program, index) => <div key={index} className="bg-white border border-teal-100 p-6 rounded-xl shadow-md hover:shadow-lg transition duration-300 transform hover:-translate-y-1" data-id="element-250">
                <div className="flex items-start mb-3" data-id="element-251">
                  <span className="bg-teal-100 text-teal-700 p-1 rounded-full mr-3" data-id="element-252">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" data-id="element-253">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-254" />
                    </svg>
                  </span>
                  <h4 className="text-lg font-medium text-teal-900" data-id="element-255">
                    {program.title}
                  </h4>
                </div>
                <p className="text-gray-700 ml-9" data-id="element-256">{program.description}</p>
              </div>)}
          </div>
        </div>
        <div className="text-center mt-12 p-6 bg-teal-50 rounded-xl" data-id="element-257">
          <p className="text-lg font-medium text-teal-800" data-id="element-258">
            Plus all new releases and upgrades included for life.
          </p>
        </div>
      </div>
    </section>;
};
export default ProgramsSection;